module.exports = __webpack_public_path__ + "static/media/picture5.c231fa5b.jpg";